import { createRouter, createWebHistory } from "vue-router";

// Layout
import MainLayout from "../layouts/MainLayout.vue";

// Views
import HomeView from "@/views/HomeView.vue";
import LoginView from "@/views/LoginView.vue";
import FileManagerView from "@/views/filemanager/pages/FileManagerView.vue";
import FileManagerTabsView from "@/views/filemanager/pages/FileManagerTabsView.vue";

import LegacyUploadView from "@/views/LegacyUploadView.vue"

const routes = [
  {
    path: "/login",
    component: LoginView,
  },

  {
    path: "/",
    component: MainLayout,
    children: [
      {
        path: "",
        component: HomeView,
      },
    ],
  },

  {
    path: "/filemanager",
    component: MainLayout,
    children: [
      {
        path: "",
        component: FileManagerView,
      },
      {
        path: "copy",
        component: FileManagerTabsView
      }
    ],
  },

  {
    path: "/",
    redirect: "/login",
  },

  { path: "/:pathMatch(.*)*", redirect: "/login" },
  {
    path: "/legacy-upload",
    component: LegacyUploadView,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
